export default {"src":"/_next/static/media/affiliate.73adff1b.svg","height":411,"width":450};